export const FETCH_TRIPEVENTS_INIT = "FETCH_TRIPEVENTS_INIT";
export const FETCH_TRIPEVENTS_SUCCESS = FETCH_TRIPEVENTS_INIT + "_SUCCESS";
export const FETCH_TRIPEVENTS_FAIL = FETCH_TRIPEVENTS_INIT + "_FAIL";

export const FETCH_TRIPBYID_INIT = "FETCH_TRIPBYID_INIT";
export const FETCH_TRIPBYID_SUCCESS = FETCH_TRIPBYID_INIT + "_SUCCESS";
export const FETCH_TRIPBYID_FAIL = FETCH_TRIPBYID_INIT + "_FAIL";

export const FETCH_TRIPLOG_INIT = "FETCH_TRIPLOG_INIT";
export const FETCH_TRIPLOG_SUCCESS = FETCH_TRIPLOG_INIT + "_SUCCESS";
export const FETCH_TRIPLOG_FAIL = FETCH_TRIPLOG_INIT + "_FAIL";

export const TRIP_ADD_DOC_INIT = "TRIP_ADD_DOC_INIT";
export const TRIP_ADD_DOC_SUCCESS = TRIP_ADD_DOC_INIT + "_SUCCESS";
export const TRIP_ADD_DOC_FAIL = TRIP_ADD_DOC_INIT + "_FAIL";

export const DELETE_DOC_INIT = "DELETE_DOC_INIT";
export const DELETE_DOC_SUCCESS = DELETE_DOC_INIT + "_SUCCESS";
export const DELETE_DOC_FAIL = DELETE_DOC_INIT + "_FAIL";

export function fetchTripEvents(value) {
  return {
    type: FETCH_TRIPEVENTS_INIT,
    payload: value,
  };
}

export function fetchSpecificTripdata(value) {
  return {
    type: FETCH_TRIPBYID_INIT,
    payload: value,
  };
}

export function fetchTriplog(value) {
  return {
    type: FETCH_TRIPLOG_INIT,
    payload: value,
  };
}

export function addDocument(value) {
  return {
    type: TRIP_ADD_DOC_INIT,
    value: value,
  };
}

export function deleteDocument(value) {
  return {
    type: DELETE_DOC_INIT,
    value: value,
  };
}
